import React from "react";

/**
 * The ORIGINAL onboarding kit pieces (pre-2026-10-24 look: light theme,
 * inline styles, #0065F8 accent), kept for MakeWelcome — the
 * make.pixleyai.com family welcome — which is laid out on them and is live.
 * The website onboarding itself now uses NOKit, restyled to the web funnel
 * with `.fs-*` / `.ob-*` classes that MakeWelcome does not render.
 */

export const FREDOKA = { fontFamily: "'Fredoka', sans-serif" };

export const NO = {
  accent: "#0065F8",
  ink: "#0B1A33",
  subtitle: "#5A6B85",
  cardStroke: "#E8EDF5",
  track: "#DDE6F2",
  red: "#FF4B4B",
  deepBlue: "#073B8E",
};

// Eyebrow + title (with one accent-colored segment) + optional subtitle.
export const StepHeading = ({ eyebrow, title, accent, subtitle }) => (
  <div className="w-full text-center sm:text-left">
    {eyebrow && (
      <div
        style={{
          ...FREDOKA,
          color: NO.accent,
          fontWeight: 700,
          fontSize: 14,
          letterSpacing: 2,
          textTransform: "uppercase",
        }}
      >
        {eyebrow}
      </div>
    )}
    <h1
      style={{
        ...FREDOKA,
        color: NO.ink,
        fontWeight: 700,
        fontSize: "clamp(28px, 5vw, 34px)",
        lineHeight: 1.15,
        marginTop: eyebrow ? 8 : 0,
      }}
    >
      {title}
      {accent && <span style={{ color: NO.accent }}> {accent}</span>}
    </h1>
    {subtitle && (
      <p style={{ ...FREDOKA, color: NO.subtitle, fontSize: 17, marginTop: 10 }}>
        {subtitle}
      </p>
    )}
  </div>
);


// Standard footer Continue pill (web brand 3D-press style, iOS chevron).
export const ContinueButton = ({ onClick, disabled, loading, label = "Continue" }) => (
  <button
    onClick={onClick}
    disabled={disabled || loading}
    className="inline-flex items-center gap-2 transition active:scale-[0.97] disabled:opacity-50 disabled:cursor-not-allowed"
    style={{
      ...FREDOKA,
      background: NO.accent,
      color: "#FFFFFF",
      fontWeight: 700,
      fontSize: 15,
      border: "none",
      borderRadius: 999,
      padding: "12px 22px",
      boxShadow: `0px 4px 0px ${NO.deepBlue}, 0px 12px 24px rgba(0,101,248,0.22)`,
      cursor: disabled || loading ? "not-allowed" : "pointer",
    }}
  >
    {loading ? (
      <>
        <span
          style={{
            width: 14,
            height: 14,
            borderRadius: "50%",
            border: "2px solid rgba(255,255,255,0.30)",
            borderTopColor: "#FFFFFF",
            animation: "nol-spin 1s linear infinite",
          }}
        />
        Loading…
      </>
    ) : (
      <>
        {label}
        <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.6" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </>
    )}
  </button>
);
